import { useAtom } from "jotai"
import { userAtom } from "../state"
import { useMemo } from "react"

export const useIsAdmin = () => {
  const [user] = useAtom(userAtom)
  const isAdmin = useMemo(() => user?.is_admin ?? false, [user])
  return isAdmin
}
